import React from 'react';
import {IconProps} from './IconProps';

export default function IconArrowTopRight({className, height = '1em'}: IconProps) {
  return (
    <svg width={height} height={height} viewBox="0 0 19 33" fill="none" xmlns="http://www.w3.org/2000/svg"
      className={className}>
      <path d="M2 24L18 8M18 8H1M18 8V25" stroke="currentColor" strokeWidth="2"/>
    </svg>
  );
}
